<template>
  <v-container grid-list-md class="pa-0 ma-0">
    <v-flex xs12 v-if="lAction === 'view'">
      <v-layout row wrap>
        <v-flex xs12 mx-auto>
          <!-- Repository -->
          <v-flex xs12 sm12 v-for="(cat, i) in reposCat" :key = "i">
            <v-card>
              <v-card-title class="py-2 title grey lighten-4">
                {{ cat.repos_cat }}
              </v-card-title>
              <v-card-text class="pa-0" :style="reposit.filter(rec => rec.repos_cat_id === cat.repos_cat_id).length > 5 ? 'overflow-y: scroll; height: 300px; padding: 1rem 1rem 1rem 0px;' : ''">
                <v-data-table
                :headers="reposHeader"
                :items="reposit.filter(rec => rec.repos_cat_id === cat.repos_cat_id)"
                disable-initial-sort
                hide-actions
                >
                <template slot="items" slot-scope="props">
                  <tr>
                    <td> {{ props.item.doc_name ? props.item.doc_name : '-' }} </td>
                    <td>
                      <a :href="config.FILE_URL(props.item.doc_url)" download style="text-decoration: none;">
                        <v-btn small icon class="mr-0 grey lighten-1 grey--text text--lighten-4">
                          <v-icon small>file_download</v-icon>
                        </v-btn>
                      </a>
                    </td>
                    <td>{{ props.item.upload_dt ? handy.formatDBDateTime(props.item.upload_dt) : '-' }}</td>
                    <td>{{ props.item.remarks ? props.item.remarks : '-' }}</td>
                    <td @click="prepareUpdateReposit(props.item)">
                      <v-btn small icon class="mr-0">
                        <v-icon small>create</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-flex>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn v-if="lAction === 'view'" v-on="on"
          :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
          dark fab fixed
          color="accent"
          @click.native="prepareRepository()">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <span class="caption">Add Repository</span>
    </v-tooltip>
  </v-layout>
</v-flex>

<!-- Insert, Update and Delete Repository -->
<v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-2" grid-list-md>
  <v-layout row wrap>
    <v-flex xs8 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveChanges(lAction)">
        <v-card>
          <v-card-title class="py-3 title">
            {{ handy.startWithUpper(lAction) }} Repository
          </v-card-title>
          <v-card-text class="px-2 pb-2 pt-0">
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                v-model="lReposit.repos_cat_id"
                :items="reposCat"
                label="Repository Category"
                item-text="repos_cat"
                item-value="repos_cat_id"
                hide-details
                :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                v-model="lReposit.remarks"
                label="Remarks (if any)"
                rows="2"
                hide-details
                maxlength="250"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 v-if="lAction === 'create'">
                <input style="display:none" type="file" ref="fileInput"
                accept=".xls, .xlsx, .csv, .pdf, .ppt, .pptx, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser(lReposit)"/>
                <v-btn icon @click="pickFile"><v-icon>attach_file</v-icon></v-btn>
                <span v-if="lReposit.files && lReposit.files.filter(rec => rec.is_selected).length > 0">
                  <span v-for="(file, index) in lReposit.files.filter(rec => rec.is_selected)" :key="index">
                    <v-chip v-model="file.is_selected" @input="$forceUpdate()" close>{{ file.doc_name }}</v-chip>
                  </span>
                </span>
                <span v-else class="caption">Attachment if any (upto 20MB)</span>
              </v-flex>
              <v-flex xs12 v-else>
                <input style="display:none" type="file" ref="fileInput"
                accept=".xls, .xlsx, .csv, .pdf, .ppt, .pptx, .doc, .docx, image/png, image/gif, image/jpeg" @change="loadFilesFromFileBrowser(lReposit)"/>
                <v-btn v-if="lReposit.files && lReposit.files.filter(rec => rec.is_selected).length === 0" icon @click="pickFile"><v-icon>attach_file</v-icon></v-btn>
                <span v-if="lReposit.files && lReposit.files.filter(rec => rec.is_selected).length > 0">
                  <span v-for="(file, index) in lReposit.files.filter(rec => rec.is_selected)" :key="index">
                    <v-chip v-model="file.is_selected" @input="$forceUpdate()" close>{{ file.doc_name }}</v-chip>
                  </span>
                </span>
                <span v-else class="caption">Attachment if any (upto 20MB)</span>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-3">
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-btn @click.stop="cancelChanges">Cancel</v-btn>
              <v-btn v-if="lAction === 'update'" @click="deleteReposit(lReposit)">delete</v-btn>
              <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar" :timeout="3000" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      // Common Declarations
      handy: handy,
      config: config,
      lAction: '',
      sbarCol: '',
      sbarMsg: '',
      sbar: false,
      rules: handy.rules,
      // Repository Category Declarations
      reposCat: [],
      // Repository Declarations
      reposit: [],
      beingSaved: false,
      reposHeader: [
        { text: 'Document Name', value: 'doc_name', width: '290px' },
        { text: 'Download', value: '', width: '100px' },
        { text: 'Upload Date', value: 'upload_dt', width: '210px' },
        { text: 'Remarks', value: 'remarks', width: '400px' },
        { text: 'Actions', value: '' }
      ],
      lReposit: []
    }
  },
  created () {
    this.lAction = 'view'
    this.loadReposCat()
    this.loadRepository()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadReposCat () {
      this.axios.get(config.API_URL + '/getRepositoryCategory/')
      .then(response => {
        this.reposCat = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    prepareRepository () {
      this.lReposit = {
        comm_id: config.COMM_ID,
        repos_cat_id: null,
        remarks: '',
        files: []
      }
      this.lAction = 'create'
    },
    pickFile () {
      this.$refs.fileInput.click()
    },
    loadFilesFromFileBrowser (curReposit) {
      const files = event.target.files
      if (!curReposit.files) {
        curReposit.files = []
      }
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            curReposit.files.push({
              doc_url: e.target.result.split(',')[1],
              doc_name: file.name,
              is_selected: true,
              is_changed: true
            })
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
    },
    saveChanges (action) {
      if (this.$refs.lForm.validate()) {
        if (this.lReposit.files.length > 0 && this.lReposit.files.filter(rec => rec.is_selected).length > 0) {
          // this.beingSaved = true
          var selectedFiles = this.lReposit.files.filter(rec => rec.is_selected)
          var qry = {
            params: {
              comm_id: this.lReposit.comm_id,
              repos_cat_id: this.lReposit.repos_cat_id,
              files: selectedFiles.map(rec => rec.doc_name)
            }
          }
          this.axios.get(config.API_URL + '/getListOfDuplicateFileName/', qry)
          .then(resp => {
            if (resp.data) {
              this.msg('Files with the same name already exists: ' + resp.data, 0)
            } else {
              this.axios.post(config.API_URL + '/repository/' + action, this.lReposit)
              .then(response => {
                setTimeout(() => {
                  this.loadRepository()
                }, 500)
                this.msg('Saved Successfully', 1)
                this.beingSaved = false
                this.lAction = 'view'
              })
              .catch(err => {
                this.msg(err, 0)
                this.beingSaved = false
              })
            }
          })
          .catch(err => {
            this.msg(err, 0)
            this.beingSaved = false
          })
        } else {
          this.msg('Please attach file', 0)
        }
      }
    },
    loadRepository () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getRepositoryByCommId/', qry)
      .then(response => {
        this.reposit = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    prepareUpdateReposit (curRepos) {
      this.lReposit = Object.assign({}, curRepos)
      this.lReposit.old_repos_cat_id = curRepos.repos_cat_id
      this.loadRepositAttachment(this.lReposit)
      this.lAction = 'update'
    },
    loadRepositAttachment (curReposit) {
      var path = require('path')
      var qry = {
        params: {
          doc_id: curReposit.doc_id
        }
      }
      curReposit.files = []
      this.axios.get(config.API_URL + '/getAttachmentByDocId/', qry)
      .then(response => {
        response.data.forEach((rec) => {
          curReposit.files.push({
            doc_url: rec.doc_url,
            doc_name: path.basename(rec.doc_url),
            is_selected: true,
            is_changed: false
          })
        })
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, true)
        curReposit.files = []
      })
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    deleteReposit (curReposit) {
      if (!confirm('Sure, you want to delete the Repository with name ' + curReposit.doc_name)) {
        return
      }
      // up in db
      this.axios.post(config.API_URL + '/repository/delete', curReposit)
      .then(response => {
        this.loadReposCat()
        this.loadRepository()
        this.lAction = 'view'
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
        this.beingSaved = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Repository.vue?5b5733fc